
import React from 'react';
import type { Shift } from '../../types';
import { Icons } from '../ui/Icons';

interface ShiftPaletteProps {
    shifts: Shift[];
    setDraggedShiftId: (id: string | null) => void;
    isCollapsed: boolean;
    onToggleCollapse: () => void;
}

const ShiftPalette: React.FC<ShiftPaletteProps> = ({ shifts, setDraggedShiftId, isCollapsed, onToggleCollapse }) => {
    const handleDragStart = (e: React.DragEvent<HTMLDivElement>, shiftId: string) => {
        e.dataTransfer.setData('shiftId', shiftId);
        setDraggedShiftId(shiftId);
    };

    const handleDragEnd = () => {
        setDraggedShiftId(null);
    };

    return (
        <div className="bg-white dark:bg-slate-800 p-4 rounded-lg shadow-md sticky top-[calc(4rem+1rem)] sm:top-[calc(4rem+1.5rem)] lg:top-[calc(4rem+2rem)] h-[calc(100vh-8rem)] flex flex-col">
            <div className="flex items-center mb-4 flex-shrink-0">
                {!isCollapsed && <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">Shifts</h3>}
                <button
                    onClick={onToggleCollapse}
                    className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 text-gray-600 dark:text-gray-300 ml-auto"
                    title={isCollapsed ? "Expand" : "Collapse"}
                >
                    {isCollapsed ? <Icons.ChevronRight className="w-5 h-5" /> : <Icons.ChevronLeft className="w-5 h-5" />}
                </button>
            </div>

            {!isCollapsed && (
                <>
                    <div className="flex-grow space-y-2 mb-4 overflow-y-auto min-h-0">
                        {shifts.map(shift => (
                            <div
                                key={shift.id}
                                draggable
                                onDragStart={(e) => handleDragStart(e, shift.id)}
                                onDragEnd={handleDragEnd}
                                className="p-2 rounded-md cursor-grab active:cursor-grabbing flex justify-between items-center text-white font-medium"
                                style={{ backgroundColor: shift.color }}
                            >
                                <span>{shift.name}</span>
                                <span className="text-sm opacity-80">{shift.startTime} - {shift.endTime}</span>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default ShiftPalette;